import { Cloudinary } from "@cloudinary/url-gen";
import { format } from "@cloudinary/url-gen/actions/delivery";
import { scale } from "@cloudinary/url-gen/actions/resize";

import { getPublicConfig } from "@/helpers/getPublicConfig";

const {
  services: {
    cloudinary: { cloudName },
  },
} = getPublicConfig();

type Options = {
  size: number;
};

export function getImageUrl(publicId: string, options?: Options) {
  const cloudinary = new Cloudinary({
    cloud: { cloudName },
  });

  const imageReturn = cloudinary
    .image(publicId)
    .delivery(format("jpg").lossy());

  if (options?.size) {
    return imageReturn.resize(scale().width(options.size)).toURL();
  }

  return imageReturn.toURL();
}
